import { Col, Row } from "reactstrap";
import moment from "moment";
import {
  foodPreOrderEventGuestAccept,
  foodPreOrderEventGuestAcceptSuccess,
  foodPreOrderEventGuestData,
  foodPreOrderEventGuestDecline,
  foodPreOrderEventGuestDeclineSuccess,
} from "../../../../../../store/foodPreOederEvent/action";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import React, { useEffect } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../../../../Components/Common/Spinner";

const EventDetails = ({
  eventDetails,
  eventUserData,
  branding,
  setActiveTab,
}) => {
  console.log("eventUserData", eventUserData);
  const params = useParams();
  const dispatch = useDispatch();

  const { foodPreOrderEventGuestDataAPI, foodPreOrderEventGuestDataLoading } =
    useSelector((state) => ({
      foodPreOrderEventGuestDataAPI:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestData
          ?.foodpreordereventguest_data,
      foodPreOrderEventGuestDataLoading:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestDataLoading,
    }));
  console.log("foodPreOrderEventGuestDataAPI", foodPreOrderEventGuestDataAPI);
  const handleAcceptDeclineInvite = (type) => {
    if (type === "accept") {
      dispatch(
        foodPreOrderEventGuestAccept(
          { id: eventUserData?.data?.FoodPreOrderEventGuest_Id },
          params?.token
        )
      );
    }
    if (type === "decline") {
      dispatch(
        foodPreOrderEventGuestDecline(
          { id: eventUserData?.data?.FoodPreOrderEventGuest_Id },
          params?.token
        )
      );
    }
  };
  const { foodPreOrderEventGuestAcceptAPI, foodPreOrderEventGuestDeclineAPI } =
    useSelector((state) => ({
      foodPreOrderEventGuestAcceptAPI:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestAccept,
      foodPreOrderEventGuestDeclineAPI:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestDecline,
    }));

  //Accept
  useEffect(() => {
    if (isEmpty(foodPreOrderEventGuestAcceptAPI)) return;
    if (foodPreOrderEventGuestAcceptAPI.status === 200) {
      toast.success(foodPreOrderEventGuestAcceptAPI?.message);
      dispatch(
        foodPreOrderEventGuestData(
          { id: eventUserData?.data?.FoodPreOrderEventGuest_Id },
          params?.token
        )
      );
      setActiveTab("2");
    } else {
      toast.error(foodPreOrderEventGuestAcceptAPI?.message);
    }

    dispatch(foodPreOrderEventGuestAcceptSuccess([]));
  }, [foodPreOrderEventGuestAcceptAPI]);

  //Decline
  useEffect(() => {
    if (isEmpty(foodPreOrderEventGuestDeclineAPI)) return;
    if (foodPreOrderEventGuestDeclineAPI.status === 200) {
      toast.success(foodPreOrderEventGuestDeclineAPI?.message);
      dispatch(
        foodPreOrderEventGuestData(
          { id: eventUserData?.data?.FoodPreOrderEventGuest_Id },
          params?.token
        )
      );
    } else {
      toast.error(foodPreOrderEventGuestDeclineAPI?.message);
    }

    dispatch(foodPreOrderEventGuestDeclineSuccess([]));
  }, [foodPreOrderEventGuestDeclineAPI]);

  // Task 24837 - the guest's own view of their booking.
  //
  // What this replaced: everything centre-aligned in two cramped columns, a
  // second "Event Details" heading directly under the tab already called
  // Event Details, label-and-value runs like "Event Date:8 Oct 2026" with no
  // space after the colon, and an Accept/Decline pair the size of form
  // buttons for the single most consequential action on the page.
  //
  // Each fact now carries an icon, because a guest scanning on a phone is
  // looking for one thing - usually the date or the address - and an icon is
  // found faster than a word.

  const addressParts = [
    eventDetails?.FoodPreOrderSiteLocation_AddressLine1,
    eventDetails?.FoodPreOrderSiteLocation_AddressLine2,
    eventDetails?.FoodPreOrderSiteLocation_AddressLine3,
    eventDetails?.FoodPreOrderSiteLocation_AddressLine4,
    eventDetails?.FoodPreOrderSiteLocation_AddressCity,
    eventDetails?.FoodPreOrderSiteLocation_AddressCounty,
    eventDetails?.FoodPreOrderSiteLocation_AddressPostcode,
  ].filter(Boolean);

  const addressFull = addressParts.join(", ");

  const statusId =
    foodPreOrderEventGuestDataAPI?.FoodPreOrderEventGuestStatus_Id;
  const statusName =
    foodPreOrderEventGuestDataAPI?.FoodPreOrderEventGuestStatus_Name;

  // 2 = accepted, 3 = declined; anything else is still an open invitation.
  const statusClass =
    statusId === "2"
      ? "guest-status--accepted"
      : statusId === "3"
      ? "guest-status--declined"
      : "guest-status--pending";

  const statusIcon =
    statusId === "2"
      ? "ri-check-line"
      : statusId === "3"
      ? "ri-close-line"
      : "ri-time-line";

  const paidAmount = +foodPreOrderEventGuestDataAPI?.TotalPaymentCompletedAmount;

  // Task 24837 - "5 Oct 2026, 07:00 PM" is a fact; "closes in 17 days" is the
  // thing a guest actually needs to know, and it is the difference between
  // choosing now and meaning to.
  //
  // Guard the date hard. These columns come back as MySQL datetimes and a
  // never-set one arrives as the zero date "0000-00-00 00:00:00" - a truthy
  // string that parses to Invalid Date, whose arithmetic is NaN. NaN days
  // would render as "closes in NaN days", so anything that is not a real
  // date returns null and no pill appears at all.
  const closingCountdown = (() => {
    const raw = eventDetails?.PreOrderAllowedEndDateTime;
    if (!raw || String(raw).startsWith("0000-00-00")) return null;

    const closes = new Date(String(raw).replace(" ", "T"));
    if (isNaN(closes.getTime())) return null;

    const msLeft = closes.getTime() - Date.now();
    if (msLeft <= 0) return { text: "Closed", tone: "closed" };

    const minutes = Math.floor(msLeft / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    // Under two days it is measured in hours, because "closes in 1 day" and
    // "closes in 20 hours" ask for very different behaviour from a guest.
    if (days >= 2) return { text: `Closes in ${days} days`, tone: days <= 3 ? "soon" : "open" };
    if (hours >= 2) return { text: `Closes in ${hours} hours`, tone: "soon" };
    if (minutes >= 2) return { text: `Closes in ${minutes} minutes`, tone: "urgent" };
    return { text: "Closing now", tone: "urgent" };
  })();

  // Task 24837 - every date on this page carries its weekday.
  //
  // "8 Oct 2026" makes a guest count on their fingers to work out whether
  // they are free; "Thu 8 Oct 2026" does not. The shared HandleDateTime is
  // used on hundreds of screens so it is left alone - this is a local format
  // for a page read by the public, not by staff who live in the system.
  //
  // Zero dates are guarded the same way as the countdown: "0000-00-00" is a
  // truthy string that becomes Invalid Date, which would render as
  // "Invalid Date" rather than nothing at all.
  const formatGuestDateTime = (raw) => {
    if (!raw || String(raw).startsWith("0000-00-00")) return null;
    const parsed = moment(String(raw).replace(" ", "T"));
    if (!parsed.isValid()) return null;
    return parsed.format("ddd D MMM YYYY, hh:mm A");
  };

  // Task 24837 - a small pill on the end of the address line rather than a
  // link on a row of its own. It belongs to the address, so it sits with it.
  const MapsPill = () => (
    <a
      className="guest-maps-pill"
      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        addressFull
      )}`}
      target="_blank"
      rel="noreferrer"
    >
      <i className="ri-map-pin-line" />
      Open in Maps
    </a>
  );

  const Detail = ({ icon, label, value }) =>
    value ? (
      <div className="guest-detail">
        <i className={`${icon} guest-detail__icon`} />
        <div>
          <div className="guest-detail__label">{label}</div>
          <div className="guest-detail__value">{value}</div>
        </div>
      </div>
    ) : null;

  return (
    <div>
      <Row className="g-4">
        <Col md={7}>
          {eventDetails?.Title && (
            <h3 className="guest-title mb-3">{eventDetails.Title}</h3>
          )}

          <Detail
            icon="ri-calendar-event-line"
            label="When"
            value={formatGuestDateTime(eventDetails?.EventDateTime)}
          />
          {/* Task 24837 - the address used to appear twice: once here and
              again under a "Location" heading in the right-hand column. The
              right column is now the invitation, so the maps link comes down
              to sit with the address it opens.

              The venue NAME has to come with it. It used to live only in the
              column that has gone, and the old value here was
              "addressFull || BusinessName" - a fallback, so on any event with
              an address the name was never shown at all. It is the line a
              guest looks for first: you go to Scoozi Ristorante, not to
              18 Hill Road. */}
          <Detail
            icon="ri-map-pin-line"
            label="Where"
            value={
              eventDetails?.FoodPreOrderSiteLocation_BusinessName ? (
                <>
                  {eventDetails.FoodPreOrderSiteLocation_BusinessName}
                  {addressFull && (
                    <span className="guest-detail__value-sub">
                      {addressFull}
                      <MapsPill />
                    </span>
                  )}
                </>
              ) : (
                <>
                  {addressFull || null}
                  {addressFull && <MapsPill />}
                </>
              )
            }
          />
          <Detail
            icon="ri-restaurant-2-line"
            label="Food choices open"
            value={formatGuestDateTime(
              eventDetails?.PreOrderAllowedStartDateTime
            )}
          />
          <Detail
            icon="ri-time-line"
            label="Food choices close"
            value={
              <>
                {formatGuestDateTime(
                  eventDetails?.PreOrderAllowedEndDateTime
                )}
                {closingCountdown && (
                  <span
                    className={`guest-countdown guest-countdown--${closingCountdown.tone}`}
                  >
                    <i className="ri-hourglass-line" />
                    {closingCountdown.text}
                  </span>
                )}
              </>
            }
          />

        </Col>

        <Col md={5}>
          {/* Task 24837 - THE INVITATION LIVES HERE NOW.
              It used to be the last thing in the left column, below four
              rows of dates, while this column repeated the venue name and
              address that the Where row above already gave. Replying is the
              one thing this page actually asks of a guest, so it gets the
              top of the column and a card of its own. */}
          <div className="guest-rsvp">
            {foodPreOrderEventGuestDataLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                <div className="guest-rsvp__head">
                  <span className="guest-rsvp__title">Your invitation</span>
                  {statusName && (
                    <span className={`guest-status ${statusClass}`}>
                      <i className={statusIcon} />
                      {statusName}
                    </span>
                  )}
                </div>

                <p className="guest-rsvp__prompt">
                  {statusId === "4"
                    ? "If you can no longer make it, let the venue know by declining."
                    : "Can you make it?"}
                </p>

                <div className="guest-rsvp__actions">
                  {statusId !== "4" && (
                    <button
                      type="button"
                      disabled={statusId === "2"}
                      className="guest-rsvp__btn guest-rsvp__btn--yes"
                      onClick={() => handleAcceptDeclineInvite("accept")}
                    >
                      <i className="ri-check-line me-1" />
                      {statusId === "2" ? "Going" : "I can make it"}
                    </button>
                  )}
                  <button
                    type="button"
                    disabled={statusId === "3"}
                    className="guest-rsvp__btn guest-rsvp__btn--no"
                    onClick={() => handleAcceptDeclineInvite("decline")}
                  >
                    <i className="ri-close-line me-1" />
                    {statusId === "3" ? "Declined" : "I cannot make it"}
                  </button>
                </div>

                {paidAmount > 0 && (
                  <div className="guest-event-summary mt-4 mb-0">
                    <div className="guest-event-summary__row">
                      <i className="ri-bank-card-line" />
                      <span>
                        You have paid{" "}
                        <strong>£{paidAmount.toFixed(2)}</strong>
                        {+foodPreOrderEventGuestDataAPI?.TotalPaymentCompletedQuantity >
                        1
                          ? " across several payments"
                          : ""}
                        .
                      </span>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>

          {/* Task 24837 - the embedded map has gone. It renders blank while
              Google billing is disabled (Task 24498), and even working it
              only repeated what the address and the Open in Maps link in the
              left column already do - on a phone it pushed the invitation,
              the one thing this page asks for, off the screen. */}
        </Col>
      </Row>
    </div>
  );
};

export default EventDetails;
